import { useCallback, useEffect, useState } from "react";
import API from "../../lib/api";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Siren } from "@phosphor-icons/react";
import { fmtDateTime } from "../../lib/dateUtil";
import ReportIncidentDialog from "./ReportIncidentDialog";

const STATUS = { reported: "bg-sky-100 text-sky-700", investigating: "bg-amber-100 text-amber-800", closed: "bg-slate-100 text-slate-700" };

/** My Work card: one-tap incident / near-miss reporting plus the status of what I've reported. */
export default function OperativeIncidentCard({ entityType, entityId, defaultLocation, compact = false }) {
  const [open, setOpen] = useState(false);
  const [mine, setMine] = useState([]);
  const load = useCallback(() => API.get("/hse/incidents/mine").then(({ data }) => setMine(data.incidents || [])).catch(() => {}), []);
  useEffect(() => { if (!compact) load(); }, [load, compact]);

  if (compact) {
    return (
      <>
        <Button size="sm" variant="outline" className="border-red-300 text-red-700 hover:bg-red-50" onClick={() => setOpen(true)} data-testid="operative-report-incident-btn"><Siren size={14} className="mr-1" /> Report incident / near miss</Button>
        <ReportIncidentDialog open={open} onOpenChange={setOpen} entityType={entityType} entityId={entityId} defaultLocation={defaultLocation} />
      </>
    );
  }
  return (
    <div className="bg-card border border-border rounded-lg p-5 border-l-4 border-l-red-500" data-testid="operative-incident-card">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
        <h2 className="text-lg font-semibold flex items-center gap-2"><Siren className="h-5 w-5 text-red-600" weight="fill" /> Accidents &amp; near misses</h2>
        <Button size="sm" className="bg-red-600 hover:bg-red-700" onClick={() => setOpen(true)} data-testid="operative-report-incident-btn"><Siren size={14} className="mr-1" /> Report now</Button>
      </div>
      <p className="text-xs text-muted-foreground">Hurt, nearly hurt, or saw something dangerous? Report it here — near misses count. The office is told immediately.</p>
      {mine.length > 0 && (
        <div className="mt-3 space-y-1" data-testid="operative-incident-mine">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">My reports</p>
          {mine.slice(0, 5).map(i => <div key={i.id} className="flex items-center gap-2 text-xs py-1" data-testid={`operative-incident-${i.id}`}><span className="flex-1 truncate">{i.title}</span><Badge className={`text-[10px] ${STATUS[i.status]}`}>{i.status}</Badge><span className="text-muted-foreground">{fmtDateTime(i.occurred_at)}</span></div>)}
        </div>
      )}
      <ReportIncidentDialog open={open} onOpenChange={setOpen} entityType={entityType} entityId={entityId} defaultLocation={defaultLocation} onReported={load} />
    </div>
  );
}
